import { z } from 'zod';

// Schema untuk IReceiptDetail (diasumsikan)
const ReceiptDetailSchema = z.object({
  receipt_detail_id: z.string().optional(),
  receipt_id: z.string().optional(),
  invoice_id: z.string(),
});

// Schema utama untuk IReceipt
const ReceiptFormSchema = z.object({
  receipt_id: z.string().optional(),
  receipt_number: z.string().min(1, 'Receipt number is required'),
  partner_id: z.string().min(1, 'Partner ID is required'),
  date: z.date(), // Mengkonversi string ke Date
  method: z.enum(['Digital Payment', 'Bank Transfer', 'Credit Card', 'Cash', 'Memo', 'Bank'], {
    errorMap: () => ({ message: 'Please select a valid payment method' }),
  }),
  received: z.enum(['Kas Kecil', 'Bank'], {
    errorMap: () => ({ message: 'Please select a valid receiving account' }),
  }),
  amount: z
    .number()
    .positive('Amount must be greater than 0')
    .refine((val) => val > 0, 'Amount cannot be zero'),
  description: z.string().optional(),
  receipt_details: z.array(ReceiptDetailSchema).min(1, 'At least one receipt detail is required'),
});

const FormSchema = ReceiptFormSchema.omit({
  receipt_id: true,
});

export { FormSchema, ReceiptFormSchema, ReceiptDetailSchema };
